var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 24.5,
    viewBox: "0 0 24.5 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_902",
    "data-name": "Grupo 902",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1555",
    "data-name": "Trazado 1555",
    d: "M0,0H24V24H0Z",
    fill: "none",
    stroke: "#e73758",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1556",
    "data-name": "Trazado 1556",
    d: "M11.99,2A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM11.78,7h-.06a.717.717,0,0,0-.72.72v4.72a.99.99,0,0,0,.49.86l4.15,2.49a.715.715,0,1,0,.73-1.23l-3.87-2.3V7.72A.717.717,0,0,0,11.78,7Z",
    fill: "#fff",
    stroke: "#e73758",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceClock);
export default __webpack_public_path__ + "static/media/service-clock.840863aa5a8ef2cda1e690a2fba2cb47.svg";
export { ForwardRef as ReactComponent };